import route from 'riot-route';
import * as action from './action/index';
const r = route.create();
import * as constant from '@common/constant';
let currentView = null;
const mount = (tag, param = {}) => {
  if (currentView) currentView.unmount(true);
  currentView = riot.mount('#app-router', tag, param)[0];
};

r('/', () => {
  route('login', null, true);
});

r('login', () => {
  mount('login');
});

r('login/auto...', () => {
  const { mail, password } = route.query();
  action
    .login({
      mail: decodeURIComponent(mail),
      password: decodeURIComponent(password),
      saveInputCheck: false
    });
});

r('register', () => {
  mount('register');
});

r('register?key=*', (key) => {
  action.registerUrl({ key })
    .then((res) => {
      mount('register-complete', { success: true });
    })
    .catch((res) => {
      if (res.status == constant.STATUS_FAILURE_NO_TARGET) {
        action.showDialog({
          message: 'urlの期限が切れています。',
          status: 'success'
        });
        mount('register-complete', { failed: true });
      } else if (res.status == constant.STATUS_FAILURE_TOP_EXISTSOWNER) {
        action.showDialog({
          message: 'すでに存在しているアカウントです。',
          status: 'success'
        });
        mount('register-complete', { failed: true });
      } else if (res.status == constant.STATUS_FAILURE_TOP_REGISTERDONE) {
        action.showDialog({
          message: 'URLが使用済みです。',
          status: 'success'
        });
        mount('register-complete', { failed: true });
      } else {
        mount('register-complete', { failed: true });
      }
    });
});

r('password', () => {
  mount('password');
});

r('password/change?key=*', (key) => {
  action
    .checkChangePass({ key })
    .then(res => {
      mount('pass-change', { key });
    });
});

r('password/complete', (key) => {
  mount('pass-complete', { key });
});
